import {
  STORAGE_PREFIX
} from '@/config';
const storage = {
  getToken: () => {
    return JSON.parse(window.localStorage.getItem(`${STORAGE_PREFIX}token`) as string);
  },
  setToken: (token: string) => {
    window.localStorage.setItem(`${STORAGE_PREFIX}token`, JSON.stringify(token));
  },
  clearToken: () => {
    window.localStorage.removeItem(`${STORAGE_PREFIX}token`);
  },
  getSAToken: () => {
    return JSON.parse(window.localStorage.getItem(`${STORAGE_PREFIX}admin`) as string);
  },
  setSAToken: (token: string) => {
    window.localStorage.setItem(`${STORAGE_PREFIX}admin`, JSON.stringify(token));
  },
  clearSAToken: () => {
    window.localStorage.removeItem(`${STORAGE_PREFIX}admin`);
  },
  getFCMToken: (key: string) => {
    return window.localStorage.getItem(`${STORAGE_PREFIX}${key}`) as string;
  },
  setFCMToken: (key: string, token: string) => {
    window.localStorage.setItem(`${STORAGE_PREFIX}${key}`, token);
  },
  clearFCMToken: (key: string) => {
    window.localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
  },
  getKey: (key: string) => {
    return window.localStorage.getItem(`${STORAGE_PREFIX}${key}`) as string;
  },
  setKey: (key: string, token: string) => {
    window.localStorage.setItem(`${STORAGE_PREFIX}${key}`, token);
  },
  clearKey: (key: string) => {
    window.localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
  },
};

export default storage;
